/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   LocalUser Reducer
 */

import { User } from '@zcode/bizos'
import { filterActions } from '@zumper/redux-ignore'
import { RECEIVE_LOCALIZER_VALUES, SET_LOCAL_USER } from '../actions/constants'

const whitelist = [RECEIVE_LOCALIZER_VALUES, SET_LOCAL_USER]
const localUserReducer = function localUser(state = new User({}), action = {}) {
  switch (action.type) {
    case SET_LOCAL_USER:
      // action.user object's field names are same as the `response.user` from `bundle` GET API call
      return action.user
    case RECEIVE_LOCALIZER_VALUES: {
      const { payload } = action
      const { user } = payload
      if (user) {
        return new User(user)
      }
      return state
    }
    default:
      return state
  }
}

export default filterActions(localUserReducer, whitelist)
